import React, {PropTypes} from 'react';

const IconStatList = ({children}) => {
  const iconStatItems = React.Children.map(children, (child, index) => (
    <div className="icon-stats__item" key={`icon-stats__item-${index}`}>{child}</div>
  ));
  return (
    <div className="icon-stats">
      {iconStatItems}
    </div>);
};

IconStatList.propTypes = {
  children: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.node),
    React.PropTypes.node,
  ]),
  classNames: PropTypes.string,
};

export default IconStatList;

